import { merge } from 'lodash';

const defaultAttrs = {
  totalLiquidity: true,
  poolCount: true,
  id: true,
  totalSwapCount: true,
  totalSwapFee: true,
  totalSwapVolume: true
};

export default (attrs = {}) => ({
  balancers: {
    ...merge({}, defaultAttrs, attrs)
  }
});
